const zhTW = {
  // Nav
  nav_home: '首頁',
  nav_products: '產品中心',
  nav_about: '關於我們',
  nav_contact: '聯絡我們',
  nav_explore: '探索產品',

  // Hero
  hero_badge: '專注貓抓板 · 專業品質',
  hero_title1: '與貓共生',
  hero_title2: '每一次磨爪',
  hero_title3: '都是愉悅的儀式',
  hero_desc: '精選天然材料，融合人體工學設計，讓貓咪愛上抓板，讓家居更加美好。Koorpet，守護每一個爪印背後的幸福。',
  hero_btn_products: '探索產品系列',
  hero_btn_about: '了解品牌故事',
  hero_stat1_num: '6+',
  hero_stat1_label: '年行業深耕',
  hero_stat2_num: '50+',
  hero_stat2_label: '款產品系列',
  hero_stat3_num: '10萬+',
  hero_stat3_label: '隻貓咪的選擇',
  hero_scroll: '向下滾動',

  // Featured Products
  featured_label: '精選產品',
  featured_title: '明星產品',
  featured_subtitle: '貓咪最愛的系列',
  featured_view_all: '查看全部產品',
  featured_empty: '暫無精選產品',

  // Features Section
  features_badge: '核心優勢',
  features_title: '為什麼選擇 Koorpet',
  features_desc: '每一款產品都經過嚴格的研發測試，只為給貓咪提供最好的抓撓體驗',
  feature1_title: '三層高密度壓製',
  feature1_desc: '採用優質瓦楞紙三層熱壓工藝，密度是普通產品的2倍，耐抓耐磨，使用壽命更長。',
  feature2_title: '天然貓薄荷注入',
  feature2_desc: '精選有機貓薄荷均勻注入紙板層間，持久散發天然香氣，讓貓咪主動靠近使用。',
  feature3_title: '無毒環保認證',
  feature3_desc: '所有原材料通過國家環保檢測，無甲醛、無重金屬，貓咪啃咬也安全放心。',
  feature4_title: '人體工學設計',
  feature4_desc: '根據貓咪抓撓行為學研究，優化產品角度與高度，完美契合貓咪自然抓撓姿勢。',

  // Brand Section
  brand_label: '/ 關於我們',
  brand_title1: '匠心專注',
  brand_title2: '只為一塊好貓抓板',
  brand_desc: 'Koorpet 成立於2024年，是國內專注貓抓板研發與生產的領先品牌。工廠佔地4000平方米，配備全自動化生產線，年產能達500萬件。我們深信，一塊好的貓抓板不僅能保護傢俱，更能提升貓咪的生活品質。從原材料篩選到成品出廠，每一道工序都經過嚴格把控。',
  brand_years_num: '6+',
  brand_years_label: '年行業深耕',
  brand_years_desc: '擁有獨立研發團隊，持續創新產品設計，已獲得 30+ 項外觀及實用新型專利。',
  brand_cert1_label: '國家質量認證',
  brand_cert1_sub: '通過 ISO 9001',
  brand_cert2_label: '天然環保材料',
  brand_cert2_sub: '無毒無害認證',
  brand_cert3_label: '出口 10+ 國家',
  brand_cert3_sub: '國際品質標準',
  brand_cert4_label: '10萬+ 貓咪',
  brand_cert4_sub: '信賴之選',
  brand_cta: '查看企業資質',

  // CTA Section
  cta_quote_label: '鏟屎官的心聲',
  cta_quote: '"自從用了 Koorpet，我家沙發終於保住了！"',
  cta_label: '立即行動',
  cta_title1: '讓貓咪愛上',
  cta_title2: '屬於牠的專屬領地',
  cta_desc: '超過 10 萬隻貓咪已經選擇了 Koorpet。天然材料、精心設計、嚴格品控，每一款產品都是對貓咪最好的禮物。現在下單，享受品質生活。',
  cta_btn: '立即選購',

  // Reviews Section
  reviews_title: '真實鏟屎官心聲：',
  reviews_subtitle: '來自全國各地貓咪主人的真實評價',
  review1_name: '橘貓媽媽',
  review1_content: '買了雲朵系列，我家橘貓第一天就愛上了！品質超好，紙板很厚實，貓薄荷味道也很吸引牠，強烈推薦！',
  review1_product: '雲朵系列貓抓板',
  review2_name: '布偶鏟屎官',
  review2_content: '原木貓抓柱做工精細，劍麻繩纏繞很緊實，底座穩得很，我家布偶貓每天都在上面磨爪子，沙發終於保住了！',
  review2_product: '原木貓抓柱',
  review3_name: '三花貓的主人',
  review3_content: '波浪貓抓板設計很聰明，可以翻面用，性價比極高。貓咪很喜歡趴在上面睡覺，一舉兩得！',
  review3_product: '波浪貓抓板',
  review4_name: '英短爸爸',
  review4_content: '包裝很用心，產品品質沒話說。客服響應也很快，有問題秒回。已經回購三次了，是我家貓咪的最愛品牌！',
  review4_product: '貓薄荷圓形貓抓板',

  // About Banner
  about_breadcrumb_home: '首頁',
  about_breadcrumb_about: '關於我們',
  about_banner_title: '關於 Koorpet',
  about_banner_desc: '匠心品質，只為每一隻貓咪的幸福生活。我們相信，好的產品能讓人與寵物的關係更加美好。',

  // Company Stats
  stat1_num: '2024',
  stat1_label: '年創立',
  stat1_sub: '深耕寵物行業',
  stat2_num: '50+',
  stat2_label: '款產品',
  stat2_sub: '覆蓋貓咪全場景需求',
  stat3_num: '10萬+',
  stat3_label: '隻貓咪',
  stat3_sub: '信賴 Koorpet 的選擇',
  stat4_num: '30+',
  stat4_label: '項專利',
  stat4_sub: '持續創新研發實力',

  // Brand Story
  story_label: '品牌故事',
  story_float_num: '6年+',
  story_float_desc: '深耕寵物用品行業，從OEM代工到自有品牌',
  story_title1: '從一塊貓抓板',
  story_title2: '到一個品牌的誕生',
  story_p1: '2020年，John Yu 憑藉在寵物用品行業頭部企業的渠道管理經驗，敏銳洞察到貓抓板市場的巨大潛力。他從OEM代工業務起步，為多家國際寵物品牌提供高品質貓抓板產品，積累了深厚的生產技術和供應鏈資源。',
  story_p2: '在長達四年的OEM實踐中，John Yu 發現市面上許多產品缺乏真正的品質追求和用戶體驗設計。他決心創立一個屬於自己的品牌，以更高的標準重新定義貓抓板。',
  story_p3: '2024年，Koorpet 正式成立。John Yu 帶領團隊從0到1，堅持「天然材料、匠心設計、嚴格品控」的理念，將多年OEM積累的製造經驗轉化為面向全球消費者的優質產品。如今，Koorpet 已成為備受信賴的貓抓板品牌，產品遠銷多個國家和地區。',
  story_founder_name: 'John Yu',
  story_founder_role: 'Koorpet 創始人',
  story_founder_quote: '「我們不只是在做貓抓板，我們是在為每一個貓咪家庭創造更美好的共處空間。」',

  // Timeline
  timeline_label: '發展歷程',
  timeline_title: '發展歷程',
  timeline_desc: '從OEM代工到自有品牌，每一步都走得踏實。這是 Koorpet 成長的足跡。',
  milestone1_title: 'OEM業務起步',
  milestone1_desc: '開始為國際寵物品牌提供貓抓板OEM代工服務，建立供應鏈基礎，積累生產技術和品控經驗。',
  milestone2_title: '工廠擴建',
  milestone2_desc: '擴建4000平方米現代化廠房，引進全自動化生產線，年產能達500萬件。',
  milestone3_title: '出口突破',
  milestone3_desc: 'OEM產品出口至10多個國家和地區，服務超過50家海外客戶，品質獲國際認可。',
  milestone4_title: '品牌籌備',
  milestone4_desc: '組建獨立研發團隊，籌備自有品牌 Koorpet，完成首批原創產品設計和專利佈局。',
  milestone5_title: 'Koorpet 成立',
  milestone5_desc: 'Koorpet 品牌正式成立，首款高密度瓦楞紙貓抓板系列上市，獲得市場熱烈反響。',
  milestone6_title: '產品線擴展',
  milestone6_desc: '推出劍麻貓抓柱、貓爬架系列等新品，通過 ISO 9001 等國際認證，品牌影響力持續擴大。',
  milestone7_title: '用戶里程碑',
  milestone7_desc: '累計服務超過10萬隻貓咪家庭，Koorpet 成為國內貓抓板品類領先品牌，持續領跑行業。',

  // Team Section
  team_label: '核心團隊',
  team_title: '核心團隊',
  team_desc: '一群真正愛貓的人，用專業與熱情打造每一款產品',
  team_more: '以及',
  team_more2: '位充滿熱情的 Koorpet 專業團隊成員',
  team1_name: 'John Yu',
  team1_role: '創始人',
  team1_desc: '曾在行業頭部企業擔任渠道負責人，深諳寵物用品市場。基於對貓咪福祉的深刻洞察和對產品品質的不懈追求，於2024年創立 Koorpet，帶領團隊從OEM代工到自有品牌，實現了從0到1的突破。',
  team1_tag1: '品牌創立',
  team1_tag2: '渠道拓展',
  team2_name: '林曉雯',
  team2_role: '首席設計師',
  team2_desc: '畢業於中央美術學院工業設計專業，深耕寵物產品設計8年，主導了 Koorpet 30餘款產品的外觀設計。',
  team2_tag1: '產品設計',
  team2_tag2: '用戶體驗',
  team3_name: '王建國',
  team3_role: '研發總監',
  team3_desc: '材料工程學博士，專注寵物用品材料研發10年，主導了 Koorpet 低粉塵配方和貓薄荷注入工藝的研發。',
  team3_tag1: '材料研發',
  team3_tag2: '工藝創新',
  team4_name: '張美玲',
  team4_role: '品質總監',
  team4_desc: '擁有ISO質量管理體系認證資質，負責 Koorpet 全線產品的品質把控，確保每一件產品都達到出廠標準。',
  team4_tag1: '品質管控',
  team4_tag2: 'ISO認證',

  // Certificates
  cert_label: '資質榮譽',
  cert_title: '資質榮譽',
  cert_desc: '多項權威認證與行業認可，是對 Koorpet 品質與創新的最好證明',
  cert1_title: 'ISO 9001',
  cert1_sub: '質量管理體系認證',
  cert1_desc: '通過國際質量管理體系認證，生產流程全程可追溯，品質有保障。',
  cert1_year: '2018年獲得',
  cert2_title: '環保無毒認證',
  cert2_sub: '國家環保檢測合格',
  cert2_desc: '所有原材料通過國家環保檢測，無甲醛、無重金屬，貓咪啃咬也安全。',
  cert2_year: '2017年獲得',
  cert3_title: '寵物用品安全認證',
  cert3_sub: '中國寵物用品協會',
  cert3_desc: '獲得中國寵物用品協會頒發的安全認證，是行業內少數獲此認證的品牌之一。',
  cert3_year: '2019年獲得',
  cert4_title: 'CE 歐盟認證',
  cert4_sub: '歐盟市場准入資質',
  cert4_desc: '通過歐盟CE認證，產品符合歐盟安全、健康、環保標準，可在歐盟市場銷售。',
  cert4_year: '2020年獲得',
  awards_title: '榮譽獎項',
  award1_title: '年度寵物用品創新設計獎',
  award1_org: '中國寵物產業博覽會',
  award2_title: '最受鏟屎官信賴品牌',
  award2_org: '寵物之家年度評選',
  award3_title: '國家高新技術企業認定',
  award3_org: '廣東省科技廳',
  award4_title: '廣東省著名商標',
  award4_org: '廣東省工商行政管理局',
  award5_title: '寵物用品出口優質企業',
  award5_org: '廣州市商務局',
  award6_title: '廣州市優秀中小企業',
  award6_org: '廣州市工業和信息化局',

  // About CTA
  about_cta_label: '加入我們',
  about_cta_title1: '一起為貓咪創造',
  about_cta_title2: '更美好的生活',
  about_cta_btn1: '探索產品',
  about_cta_btn2: '聯絡我們',

  // Products Banner
  products_breadcrumb_home: '首頁',
  products_breadcrumb: '產品中心',
  products_banner_title: '產品中心',
  products_banner_desc: '精選天然材料，匠心打造每一款貓抓板，讓貓咪愛上磨爪的儀式感',

  // Product Filter
  filter_all: '全部',
  filter_count: '共',
  filter_count2: '款產品',
  sort_default: '預設排序',
  sort_price_asc: '價格從低到高',
  sort_price_desc: '價格從高到低',
  category_corrugated: '瓦楞紙',
  category_sisal: '劍麻',
  category_combo: '綜合',

  // Product Card
  product_view_detail: '查看詳情',

  // Product Detail
  detail_product_code: '產品代碼',
  detail_not_found: '找不到該產品',
  detail_back_to_products: '返回產品列表',

  // Tags
  tag_hot_selling: '熱銷中',
  tag_new: '新品',
  tag_corrugated_paper: '瓦楞紙',
  tag_limited_offer: '限時優惠',
  tag_bestseller: '爆款',
  tag_recommended: '推薦',
  tag_catnip: '貓薄荷',
  tag_sisal: '劍麻',
  tag_corner_protector: '護角',
  tag_cat_tree: '爬架',
  tag_eco_friendly: '環保',

  // Highlight Titles
  highlight_title_triple_layer: '三層熱壓工藝',
  highlight_title_catnip_infused: '有機貓薄荷注入',
  highlight_title_eco_certified: '環保無毒認證',
  highlight_title_anti_slip: '防滑底部設計',
  highlight_title_natural_sisal: '天然劍麻繩',
  highlight_title_solid_wood: '實木底座',
  highlight_title_golden_height: '60cm黃金高度',
  highlight_title_nail_care: '自然修爪',
  highlight_title_double_sided: '雙面可用',
  highlight_title_wave_curve: '波浪曲面設計',
  highlight_title_low_dust: '低粉塵配方',
  highlight_title_rubber_strip: '防滑橡膠條',
  highlight_title_sofa_design: '專為沙發設計',
  highlight_title_tool_free: '免工具安裝',
  highlight_title_sofa_safe: '不損傷沙發',
  highlight_title_set_of_4: '一套4個',
  highlight_title_catnip_builtin: '有機貓薄荷內嵌',
  highlight_title_round_design: '圓形美觀設計',
  highlight_title_safe_edge: '邊緣安全處理',
  highlight_title_hot_seller: '熱銷爆款',
  highlight_title_three_level: '三層平台設計',
  highlight_title_15kg_capacity: '承重15kg+',
  highlight_title_hanging_toy: '懸掛玩具配件',
  highlight_title_wide_base: '寬大穩固底盤',

  // Highlight Descriptions
  highlight_desc_triple_layer: '密度是普通產品2倍，更耐抓',
  highlight_desc_catnip_infused: '持久香氣，貓咪主動靠近',
  highlight_desc_eco_certified: '啃咬也安全放心',
  highlight_desc_anti_slip: '使用時穩固不移位',
  highlight_desc_natural_sisal: '手工纏繞，粗細均勻韌性足',
  highlight_desc_solid_wood: '松木防腐處理，穩固不倒',
  highlight_desc_golden_height: '滿足貓咪站立伸展需求',
  highlight_desc_nail_care: '有效修剪貓爪，保護傢俱',
  highlight_desc_double_sided: '翻轉繼續使用，壽命翻倍',
  highlight_desc_wave_curve: '契合貓咪自然抓撓姿勢',
  highlight_desc_low_dust: '紙屑少，保持家居整潔',
  highlight_desc_rubber_strip: '使用時穩固不移位',
  highlight_desc_sofa_design: '完美貼合沙發角，全方位保護',
  highlight_desc_tool_free: '強力魔術貼，30秒搞定',
  highlight_desc_sofa_safe: '背面保護層，不留痕跡',
  highlight_desc_set_of_4: '同時保護沙發四個角',
  highlight_desc_catnip_builtin: '解決貓咪不愛用抓板難題',
  highlight_desc_round_design: '可平放可掛牆，一物兩用',
  highlight_desc_safe_edge: '無毛刺，貓咪使用安全',
  highlight_desc_hot_seller: '月銷超5000件，好評如潮',
  highlight_desc_three_level: '滿足貓咪喜歡高處的天性',
  highlight_desc_15kg_capacity: '多貓家庭也能放心使用',
  highlight_desc_hanging_toy: '激發貓咪玩耍興趣',
  highlight_desc_wide_base: '跳躍也不傾倒',

  // Additional Tags
  tag_double_sided: '雙面可用',
  tag_sofa_protector: '護沙發',
  tag_multi_function: '多功能',

  detail_tab_desc: '產品詳情',
  detail_tab_specs: '規格參數',
  detail_tab_faq: '常見問題',
  detail_spec_material: '材質',
  detail_spec_size: '尺寸',
  detail_spec_weight: '重量',
  detail_spec_moq: '最小訂購量',
  detail_spec_suitable: '適用貓咪',
  detail_spec_suitable_val: '所有體型',
  detail_spec_package: '包裝內容',
  detail_spec_package_val: '產品本體 × 1，說明書 × 1',

  detail_save: '省',
  detail_save_unit: '元',
  detail_btn_consult: '諮詢購買',
  related_title: '你可能還喜歡',
  related_view_all: '查看全部',

  // Products CTA
  products_cta_title: '找不到合適的產品？',
  products_cta_desc: '聯繫我們，提供定製化解決方案，滿足您的個性化需求',
  products_cta_btn: '聯繫我們',

  // Contact Banner
  contact_breadcrumb_home: '首頁',
  contact_breadcrumb: '聯絡我們',
  contact_banner_title: '聯絡我們',
  contact_banner_desc: '無論是產品諮詢、合作洽談還是售後服務，我們隨時準備為您提供幫助',

  // Contact Form
  contact_form_label: '發送訊息',
  contact_form_title: '給我們留言',
  contact_form_desc: '填寫下方表單，我們將在1個工作日內回覆您',
  contact_form_success_title: '留言已發送！',
  contact_form_success_desc: '感謝您的留言，我們將在1個工作日內與您聯繫。',
  contact_form_success_btn: '再次留言',
  contact_form_name: '您的姓名',
  contact_form_name_placeholder: '請輸入您的姓名',
  contact_form_phone: '聯絡電話',
  contact_form_phone_placeholder: '請輸入您的手機號碼',
  contact_form_email: '電子郵箱',
  contact_form_email_placeholder: '請輸入您的郵箱地址',
  contact_form_inquiry: '諮詢類型',
  contact_form_company: '公司名稱',
  contact_form_company_optional: '（選填）',
  contact_form_company_placeholder: '如有合作需求請填寫公司名稱',
  contact_form_message: '留言內容',
  contact_form_message_placeholder: '請詳細描述您的需求或問題，我們將盡快為您解答...',
  contact_form_required: '*',
  contact_form_error: '發送失敗，請稍後重試或直接撥打客服熱線',
  contact_form_sending: '發送中...',
  contact_form_submit: '發送留言',
  inquiry_type1: '產品諮詢',
  inquiry_type2: '批發合作',
  inquiry_type3: '售後服務',
  inquiry_type4: '媒體合作',
  inquiry_type5: '其他問題',

  // Contact CTA
  contact_cta_title: '還有其他問題？',
  contact_cta_desc: '查看我們的常見問題解答，或直接發送郵件至',
  contact_cta_btn_browse: '瀏覽產品',
  contact_cta_btn_email: '發送郵件',

  // Contact Info
  contact_info1_title: '公司地址',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: '查看地圖',
  contact_info2_title: '客服熱線',
  contact_info2_line1: '在線客服',
  contact_info2_line2: '週一至週五 9:00 - 18:00',
  contact_info2_action: '在線諮詢',
  contact_info3_title: '電子郵件',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: '商務合作：cs@koorpet.com',
  contact_info3_action: '發送郵件',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet 官方',
  contact_info4_line2: '透過 WhatsApp 與我們直接溝通',
  contact_info4_action: '發起對話',

  // Footer
  footer_brand_desc: '專注貓抓板研發與生產，讓每一隻貓咪都有屬於自己的快樂領地。',
  footer_nav_title: '快速導航',
  footer_products_title: '產品系列',
  footer_product1: '瓦楞紙貓抓板',
  footer_product2: '劍麻貓抓柱',
  footer_product3: '貓爬架系列',
  footer_product4: '護角系列',
  footer_product5: '貓薄荷系列',
  footer_contact_title: '聯絡我們',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: '在線客服',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: '週一至週五 9:00 - 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: '隱私政策',
  footer_terms: '使用條款',
  footer_admin: '管理後台',

  // Legal Page
  legal_breadcrumb: '法律條款',
  legal_banner_title: '法律條款',
  legal_banner_desc: '請仔細閱讀以下條款，了解我們如何保護您的權益',
  legal_updated: '最後更新',

  // Privacy Policy
  privacy_s1_title: '關於本政策',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED（以下簡稱「Koorpet」或「我們」）非常重視用戶的隱私保護。本隱私政策說明了我們如何收集、使用、存儲和保護您的個人信息。',
  privacy_s1_p2: '當您使用我們的網站、產品或服務時，即表示您同意本隱私政策的條款。如您不同意，請停止使用我們的服務。',
  privacy_s2_title: '我們收集的信息',
  privacy_s2_p1: '為了提供更好的服務，我們可能收集以下類型的信息：',
  privacy_s2_li1: '身份信息：姓名、聯繫電話、電子郵箱地址',
  privacy_s2_li2: '交易信息：訂單記錄、收貨地址、支付信息',
  privacy_s2_li3: '設備信息：IP地址、瀏覽器類型、操作系統',
  privacy_s2_li4: '使用數據：頁面訪問記錄、點擊行為、搜索關鍵詞',
  privacy_s3_title: '信息的使用方式',
  privacy_s3_p1: '我們收集的信息將用於以下目的：',
  privacy_s3_li1: '處理您的訂單並提供相關售後服務',
  privacy_s3_li2: '向您發送產品更新、促銷活動等通知（您可隨時退訂）',
  privacy_s3_li3: '改善我們的網站功能和用戶體驗',
  privacy_s4_title: '信息共享與披露',
  privacy_s4_p1: '我們不會將您的個人信息出售給第三方。在以下情況下，我們可能會共享您的信息：',
  privacy_s4_p2: '與物流合作夥伴共享配送信息；配合法律法規要求；經您明確授權的情況。',
  privacy_s5_title: '信息安全',
  privacy_s5_p1: '我們採用行業標準的安全措施保護您的個人信息，包括SSL加密傳輸、數據訪問控制等。但請注意，互聯網傳輸並非絕對安全，我們無法保證信息傳輸的絕對安全性。',
  privacy_s6_title: '您的權利',
  privacy_s6_p1: '您對自己的個人信息享有以下權利：',
  privacy_s6_li1: '查閱權：您可以隨時查閱我們持有的您的個人信息',
  privacy_s6_li2: '更正權：如信息有誤，您可以要求我們更正',
  privacy_s6_li3: '刪除權：在特定情況下，您可以要求我們刪除您的個人信息',
  privacy_s7_title: '聯繫我們',
  privacy_s7_p1: '如您對本隱私政策有任何疑問，請通過以下方式聯繫我們：',

  // Terms of Use
  terms_s1_title: '接受條款',
  terms_s1_p1: '歡迎使用 Koorpet 官方網站。訪問或使用本網站，即表示您同意受本使用條款的約束。',
  terms_s1_p2: '我們保留隨時修改本條款的權利。修改後的條款將在網站上公佈，繼續使用本網站即視為接受修改後的條款。',
  terms_s2_title: '產品與購買',
  terms_s2_p1: '通過本網站購買產品時，您需遵守以下規定：',
  terms_s2_li1: '您提供的所有信息必須真實、準確、完整',
  terms_s2_li2: '您必須年滿18周歲或在監護人同意下使用本服務',
  terms_s2_li3: '產品價格可能隨時變動，以下單時顯示的價格為準',
  terms_s3_title: '配送與交付',
  terms_s3_p1: '我們將盡力按照承諾的時間配送產品，但實際配送時間可能因物流情況而有所不同。',
  terms_s3_p2: '配送範圍、運費及預計到達時間以結算頁面顯示為準。如遇不可抗力因素導致延誤，我們將及時通知您。',
  terms_s4_title: '退換貨政策',
  terms_s4_p1: '我們承諾提供優質的售後服務，退換貨政策如下：',
  terms_s4_li1: '收到商品後7天內，如產品存在質量問題，可申請退換貨',
  terms_s4_li2: '產品須保持原包裝完好，未經使用或損壞',
  terms_s4_li3: '退貨運費由責任方承擔；如屬質量問題，運費由我們承擔',
  terms_s5_title: '知識產權',
  terms_s5_p1: '本網站所有內容，包括但不限於文字、圖片、Logo、產品設計等，均受知識產權法律保護，歸 Koorpet 所有。',
  terms_s5_p2: '未經我們書面許可，您不得複製、修改、分發或以任何方式使用本網站的任何內容。',
  terms_s6_title: '免責聲明',
  terms_s6_p1: '本網站內容僅供參考。我們不對因使用本網站或依賴本網站信息而產生的任何直接或間接損失承擔責任。產品圖片僅供參考，實際產品以收到的實物為準。',
  terms_s7_title: '適用法律',
  terms_s7_p1: '本使用條款受中華人民共和國法律管轄。如發生爭議，雙方應首先協商解決；協商不成的，提交香港特別行政區有管轄權的法院訴訟解決。',
  terms_s8_title: '聯繫我們',
  terms_s8_p1: '如您對本使用條款有任何疑問，請通過以下方式聯繫我們：',
};

export default zhTW;